<template>
    <div>
        <MyCouponItem
            v-for="(campaign) in campaigns"
            :key="campaign.id"
            :campaign="campaign"
            @onRedeemCoupon="onRedeemCoupon()"
        ></MyCouponItem>
    </div>
</template>

<script>
//component
import MyCouponItem from "./MyCouponItem.vue"
import BzbsCoupon from "@/core/Coupon/service/BzbsCoupon";
export default {
    name: "MyCouponList",
    components: {
        MyCouponItem
    },
    created: function() {
        this.getMyCoupon();
    },
    data: function() {
        return {
            campaigns: [],

            isLoading: false,
            isLoaded: false,
            isHaveItem: false,
        };
    },
    methods: {
        getMyCoupon: function() {
            BzbsCoupon.getMyCoupon().subscribe({
                next: (campaigns) => {
                    //this.modal.loadingModal.hide();
                    for (var campaign of campaigns) {
                        //TODO: Add GA Tracking.
                        this.campaigns.push(campaign);
                    }
                    console.log(this.campaigns);
                    this.$emit('onLoaded');
                },
                error: (err) => {
                    this.errorApi(err);
                },
            })
        },
    }

}
</script>

<style>

</style>